export default __webpack_public_path__ + "static/Bisolvon-logo-6c5c1ee0a66f8d7b422b572106dc7732.png";